import React, { useState, useRef } from "react";
import "./style/Toolbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const MIN_ZOOM = 0.25;
const MAX_ZOOM = 1.6;
const STEP = 0.1;

const Toolbar = ({ setPdfScaleValue, toggleSidebar, label }) => {
  const [zoom, setZoom] = useState(null); // Auto
  const rafRef = useRef(null);

  const clamp = (v) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, v));

  const updateZoom = (next) => {
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      setZoom(next);
      setPdfScaleValue(next);
    });
  };

  const zoomIn = () => {
    const base = zoom ?? 1;
    updateZoom(clamp(Number((base + STEP).toFixed(2))));
  };

  const zoomOut = () => {
    const base = zoom ?? 1;
    updateZoom(clamp(Number((base - STEP).toFixed(2))));
  };

  return (
    <div className="Toolbar">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: "#fff",
          fontWeight: 600,
        }}
      >
        {label}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <div className="ZoomControls">
          <button onClick={zoomOut}>-</button>
          <span>{zoom ? `${Math.round(zoom * 100)}%` : "Auto"}</span>
          <button onClick={zoomIn}>+</button>
        </div>

        <FontAwesomeIcon
          icon={faBars}
          className="humburger"
          onClick={toggleSidebar}
          style={{ cursor: "pointer", color: "#fff" }}
        />
      </div>
    </div>
  );
};

export default Toolbar;
